export default __webpack_public_path__ + "static/media/ghost.ddf26831.svg";